import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from './translate.service';

/**
 * Use the pipe this way in your template:
 * {{'KEY'|translate:'application':'module'}}
 *
 * Example of use:
 * {{'WORKCODE_6'|translate:'webbill':'workcodes'}}
 *
 * Remember to register all used modules in the translation service.
 */

@Pipe({
    name: 'translate',
    standalone: true,
})
export class TranslatePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(key: string, application?: string, module?: string, params?: string[]): string {
        return this.translateService.translate(key, application, module, params);
    }
}
